module.exports = __webpack_public_path__ + "img/ico_hspx@2x.579ec527.png";